var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"demo"},[_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('b',[_vm._v("CANEVAS")])])])])])}]

export { render, staticRenderFns }